export default "__VITE_ASSET__BHmwKXHY__"